import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { buildGridConfig, DEFAULT_GRID_CONFIG } from './courseGridConfig';

const CONFIG_DOC = 'current';

function configRef(clubId) {
  return doc(db, 'clubs', clubId, 'course_config', CONFIG_DOC);
}

/**
 * Load a club's course-grid config. Returns the DBSC default when the club has
 * none saved, and falls back to the default (rather than throwing) on a denied
 * read or a malformed document — neither must break the Course Cards page,
 * which awaits this in its initial load. (ra-gbrd.20)
 */
export async function loadCourseGridConfig(clubId) {
  try {
    const snap = await getDoc(configRef(clubId));
    if (!snap.exists()) return { ...DEFAULT_GRID_CONFIG };
    return buildGridConfig(snap.data());
  } catch {
    return { ...DEFAULT_GRID_CONFIG };
  }
}

/** Validate then persist a club's course-grid config. */
export async function saveCourseGridConfig(clubId, config) {
  const cfg = buildGridConfig(config);
  await setDoc(configRef(clubId), {
    ...cfg,
    updated_at: serverTimestamp(),
  });
}
